(() => {
  if (window.__newsletterBotProtectionLoaded) return;
  window.__newsletterBotProtectionLoaded = true;

  const MINIMUM_FILL_TIME_MS = 3000;

  function showSuccessState(form) {
    const success = form.querySelector('[data-newsletter-success]');
    if (!success) return;

    success.hidden = false;
    success.focus({ preventScroll: true });
  }

  function protectForm(honeypot) {
    const form = honeypot.closest('form');
    if (!form || form.dataset.newsletterBotProtectionReady === 'true') return;

    const renderedAt = form.querySelector('[data-newsletter-rendered-at]');
    if (!renderedAt) return;

    renderedAt.value = String(Date.now());
    form.dataset.newsletterBotProtectionReady = 'true';

    form.addEventListener('submit', (event) => {
      const startedAt = Number(renderedAt.value);
      const submittedTooQuickly = !Number.isFinite(startedAt)
        || Date.now() - startedAt < MINIMUM_FILL_TIME_MS;
      const honeypotWasFilled = honeypot.value.trim() !== '';

      if (!honeypotWasFilled && !submittedTooQuickly) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      showSuccessState(form);
    }, true);
  }

  function protectNewsletterForms() {
    document.querySelectorAll('[data-newsletter-honeypot]').forEach(protectForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', protectNewsletterForms, { once: true });
  } else {
    protectNewsletterForms();
  }

  document.addEventListener('shopify:section:load', protectNewsletterForms);
})();
